import { FormattedMessage, useIntl } from "react-intl";
import { type ReleaseWatch, releaseWatch, useNewerRelease } from "../core/release-watch";
import styles from "./ReleaseBanner.module.css";

/**
 * A quiet offer to reload once a newer release answers than the one the page was loaded from
 * (core/release-watch.ts). Shown once per release: dismissing it hides it until yet another
 * release answers. Reload keeps the URL.
 */
export function ReleaseBanner({ watch = releaseWatch }: { watch?: ReleaseWatch }) {
  const intl = useIntl();
  const newer = useNewerRelease(watch);
  if (!newer) return null;
  return (
    <div className={styles.banner} role="status">
      <p className={styles.copy}>
        <FormattedMessage id="release.banner.body" />
      </p>
      <button type="button" className={styles.reload} onClick={() => watch.reload()}>
        <FormattedMessage id="release.banner.reload" />
      </button>
      <button
        type="button"
        className={styles.dismiss}
        aria-label={intl.formatMessage({ id: "release.banner.dismiss" })}
        onClick={() => watch.dismiss()}
      >
        ×
      </button>
    </div>
  );
}
